import axios from 'axios'
import store from '@/store'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_API}/${process.env.VUE_APP_BASE_API_VERSION}`
})

instance.interceptors.response.use(
  function (response) {
    return Promise.resolve(response)
  },

  function (error) {
    if (error.request) {
      if (!window.navigator.onLine) store.state.app.isInternetAvailable = false
    }
    if (error.response && error.response.status === 401) {}
    return Promise.reject(error)
  }
)

instance.interceptors.request.use(
  function (config) {
    store.state.app.isInternetAvailable = true
    config.headers['x-client-source'] = 'web-app'
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default instance
